/**
 * Staff acting as an organization may only select that organization's rows, so
 * a bulk action can never mix organizations. Not acting as anyone: every row
 * is selectable (updates/deletes of existing rows don't need an org).
 */
export const isRowSelectable = (
  rowEntityId: string | null | undefined,
  actingAsEntityId: string | null | undefined
): boolean => !actingAsEntityId || rowEntityId === actingAsEntityId;

/** Tooltip for create-type bulk actions (linking) that need an acting-as org. */
export const ACTING_AS_REQUIRED_HINT = 'Act as an organization to add';

/** Tooltip on a row checkbox disabled because the row is another org's. */
export const OTHER_ORG_ROW_HINT = 'Belongs to another organization';
